import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';

export interface StaffInviteCounts {
  total: number;
  pending: number;
  active: number;
  revoked: number;
  deleted: number;
}

export function useStaffInviteCounts(pageId: string) {
  const { token } = useAuth();
  return useQuery<StaffInviteCounts>({
    queryKey: ['staff-invite-counts', pageId],
    queryFn: () => fetcher(`/scanner/${pageId}/staff-invites/counts`, token),
    enabled: !!pageId,
    staleTime: 15_000,
  });
}
